import { connect } from 'react-redux'
import OncallComponent from '../components/OncallComponent'
import { setPublicHolidaysInStore } from '../../dashboard_accounting/actions'

import {
  fetchInitialData,
} from '../actions'

const mapStateToProps = (state) => {
  return {
    oncall: state.oncall,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
  setPublicHolidays: (publicHolidays) => dispatch(setPublicHolidaysInStore(publicHolidays)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OncallComponent)
